/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../../shared/generated.types'

import { api } from '../../../utils'
export const AuditEntryFragment = `
    fragment AuditEntryFragment on AuditEntry {
  date
  reference {
    id
    type
    display
  }
}
    `
export const TokenResponse = `
    fragment TokenResponse on ConfirmOTPResponse {
  access_token
  expires_in
}
    `
export const FileFragment = `
    fragment FileFragment on File {
  mimeType
  name
  url
}
    `
export const EligibilityVerificationFragment = `
    fragment EligibilityVerificationFragment on EligibilityVerification {
  ts
  isActive
  insurancePlanId
}
    `
export const BillingInsuredExternalFragment = `
    fragment BillingInsuredExternalFragment on BillingInsured {
  id
  type
  eligibilityVerified
  eligibilityVerification {
    ...EligibilityVerificationFragment
  }
  insurancePlanId
  outOfNetwork
  outOfNetworkPlan {
    state {
      code
      name
    }
    name
  }
  idNumber
  coPay
  deductible
  familyDeductible
  coinsurance
}
    `
export const BillingExternalFragment = `
    fragment BillingExternalFragment on PatientBilling {
  id
  treatmentId
  patientId
  insurances {
    ...BillingInsuredExternalFragment
  }
}
    `
export const DisplayMessageFragment = `
    fragment DisplayMessageFragment on DisplayMessage {
  en
  es
  zh_chs
  zh_tw
}
    `
export const PracticeServiceBoundaryDisplayFragment = `
    fragment PracticeServiceBoundaryDisplayFragment on PracticeServiceBoundaryDisplay {
  isDisplayed
  displayMessage {
    ...DisplayMessageFragment
  }
}
    `
export const PracticeServiceBoundaryFragment = `
    fragment PracticeServiceBoundaryFragment on PracticeServiceBoundary {
  tier
  availabilityStatus
  states
  formTypes
  display {
    ...PracticeServiceBoundaryDisplayFragment
  }
  appointmentTypeCode
  insurancePlans
  clinicalAges
  disableScheduling
  disableSchedulingDisplay {
    ...DisplayMessageFragment
  }
}
    `
export const PracticeServiceFragment = `
    fragment PracticeServiceFragment on PracticeService {
  id
  name
  displayName {
    ...DisplayMessageFragment
  }
  serviceTypeCode
  sort
  description {
    ...DisplayMessageFragment
  }
  createdDate
  modifiedDate
  outOfBounds {
    ...PracticeServiceBoundaryDisplayFragment
  }
  boundaries {
    ...PracticeServiceBoundaryFragment
  }
  appointmentTypeCode
}
    `
export const ExternalLocationFragment = `
    fragment ExternalLocationFragment on Location {
  id
  address {
    state
  }
  physicalType {
    code
  }
}
    `
export const SavePatientBillingExternalDocument = `
    mutation savePatientBillingExternal($input: SavePatientBillingExternalInput!) {
  savePatientBillingExternal(input: $input) {
    success
  }
}
    `
export const CreatePatientSubmissionDocument = `
    mutation createPatientSubmission($input: CreatePatientRegistrationSubmission!) {
  createPatientRegistrationSubmission(input: $input) {
    submissionId
    success
    message
    metaData {
      pendingVerificationOrdinalities
    }
  }
}
    `
export const UpdatePatientSubmissionDocument = `
    mutation updatePatientSubmission($input: UpdatePatientRegistrationSubmission!) {
  updatePatientRegistrationSubmission(input: $input) {
    submissionId
    success
    message
    metaData {
      pendingVerificationOrdinalities
    }
  }
}
    `
export const CompletePatientSubmissionDocument = `
    mutation completePatientSubmission($input: CompletePatientRegistrationSubmission!) {
  completePatientRegistrationSubmission(input: $input) {
    submissionId
    success
    message
  }
}
    `
export const CreateConsentPacketExternalDocument = `
    mutation createConsentPacketExternal($content: CreateConsentPacketExternalInput!) {
  createConsentPacketExternal(content: $content) {
    success
    code
    message
  }
}
    `
export const GetExternalLanguagesDocument = `
    query getExternalLanguages {
  getExternalLanguages {
    code
    display
  }
}
    `
export const GetExternalInsurancePlansDocument = `
    query getExternalInsurancePlans {
  getExternalInsurancePlans {
    _id
    name
    stateCode
    payerId
    payerName
    verificationPayerId
    verificationPayerName
    tocConfiguration {
      referralSourceFilter
      fuh7
      fuh30
      fum7
      fum30
    }
    companyName
  }
}
    `
export const GetExternalPracticeStatesDocument = `
    query getExternalPracticeStates($programCode: String) {
  getExternalPracticeStates(input: {programCode: $programCode}) {
    stateCode
    availabilityStatus
  }
}
    `
export const LoadPatientBillingExternalDocument = `
    query loadPatientBillingExternal {
  loadPatientBillingExternal {
    ...BillingExternalFragment
  }
}
    ${BillingExternalFragment}
${BillingInsuredExternalFragment}
${EligibilityVerificationFragment}`
export const GetSigningUrlExternalDocument = `
    query getSigningUrlExternal($input: GetSigningUrlExternalInput!) {
  getSigningUrlExternal(input: $input) {
    code
    message
    signingUrl
    shouldEmbed
  }
}
    `
export const GetExternalPracticeServicesDocument = `
    query getExternalPracticeServices($input: GetExternalPracticeServicesInput!) {
  getExternalPracticeServices(input: $input) {
    ...PracticeServiceFragment
  }
}
    ${PracticeServiceFragment}
${DisplayMessageFragment}
${PracticeServiceBoundaryDisplayFragment}
${PracticeServiceBoundaryFragment}`
export const GetExternalLocationsDocument = `
    query getExternalLocations($programCode: String) {
  getExternalLocations(input: {programCode: $programCode}) {
    ...ExternalLocationFragment
  }
}
    ${ExternalLocationFragment}`

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    savePatientBillingExternal: build.mutation<
      Types.SavePatientBillingExternal,
      Types.SavePatientBillingExternalVariables
    >({
      query: (variables) => ({
        document: SavePatientBillingExternalDocument,
        variables,
      }),
    }),
    createPatientSubmission: build.mutation<
      Types.CreatePatientSubmission,
      Types.CreatePatientSubmissionVariables
    >({
      query: (variables) => ({
        document: CreatePatientSubmissionDocument,
        variables,
      }),
    }),
    updatePatientSubmission: build.mutation<
      Types.UpdatePatientSubmission,
      Types.UpdatePatientSubmissionVariables
    >({
      query: (variables) => ({
        document: UpdatePatientSubmissionDocument,
        variables,
      }),
    }),
    completePatientSubmission: build.mutation<
      Types.CompletePatientSubmission,
      Types.CompletePatientSubmissionVariables
    >({
      query: (variables) => ({
        document: CompletePatientSubmissionDocument,
        variables,
      }),
    }),
    createConsentPacketExternal: build.mutation<
      Types.CreateConsentPacketExternal,
      Types.CreateConsentPacketExternalVariables
    >({
      query: (variables) => ({
        document: CreateConsentPacketExternalDocument,
        variables,
      }),
    }),
    getExternalLanguages: build.query<
      Types.GetExternalLanguages,
      Types.GetExternalLanguagesVariables | void
    >({
      query: (variables) => ({
        document: GetExternalLanguagesDocument,
        variables,
      }),
    }),
    getExternalInsurancePlans: build.query<
      Types.GetExternalInsurancePlans,
      Types.GetExternalInsurancePlansVariables | void
    >({
      query: (variables) => ({
        document: GetExternalInsurancePlansDocument,
        variables,
      }),
    }),
    getExternalPracticeStates: build.query<
      Types.GetExternalPracticeStates,
      Types.GetExternalPracticeStatesVariables | void
    >({
      query: (variables) => ({
        document: GetExternalPracticeStatesDocument,
        variables,
      }),
    }),
    loadPatientBillingExternal: build.query<
      Types.LoadPatientBillingExternal,
      Types.LoadPatientBillingExternalVariables | void
    >({
      query: (variables) => ({
        document: LoadPatientBillingExternalDocument,
        variables,
      }),
    }),
    getSigningUrlExternal: build.query<
      Types.GetSigningUrlExternal,
      Types.GetSigningUrlExternalVariables
    >({
      query: (variables) => ({
        document: GetSigningUrlExternalDocument,
        variables,
      }),
    }),
    getExternalPracticeServices: build.query<
      Types.GetExternalPracticeServices,
      Types.GetExternalPracticeServicesVariables
    >({
      query: (variables) => ({
        document: GetExternalPracticeServicesDocument,
        variables,
      }),
    }),
    getExternalLocations: build.query<
      Types.GetExternalLocations,
      Types.GetExternalLocationsVariables | void
    >({
      query: (variables) => ({
        document: GetExternalLocationsDocument,
        variables,
      }),
    }),
  }),
})

export { injectedRtkApi as api }
